module.exports = "<div class=\"card card-plain\">\n  <div class=\"card-block\">\n      <img src=\"{{imgSrc}}\" width=\"80%\">\n  </div>\n</div>\n"